import { getCssPackPath } from '@/libs/tinymce/utils/index'

// Настройки для платформ
// /crm/uc/platforms/new
export const platformSettings = {
  body_class: 'platformView__content',
  content_css: getCssPackPath(),
  height: 200,
  plugins: 'code,link,lists,table,paste',
  style_formats: [
    { title: 'p', block: 'p', classes: false },
    { title: 'Важно!', block: 'div', classes: 'important'},
  ],
  toolbar: [
    `styleselect | fontsizeselect bold italic underline | bullist numlist outdent indent | undo redo
    | link | alignleft aligncenter alignright alignjustify | code | table`,
  ],
}
